import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable()
export class DuplicatedImagesService {

  detect(images) {
    return images.map((item, index) => {
      return index > 0 &&
        moment(item.date).subtract(7.5, 'seconds').isBefore(images[index - 1].date) &&
        item.exifPresent
          ? {...item, duplicate: true}
          : item;
    });
  }

  deduplicatedImagesCount(images) {
    return this.detect(images).filter(image => !image.duplicate).length;
  }
}
